import { baseArgPath } from './apiConfig/apiConfig.js';
import { createhttp } from './lib/createHttp.js';

/**
 * Create the http clients
 */
export const argHttp = createhttp({ baseURL: baseArgPath() });
